<template>
  <div class="login_box" v-show="showLoginBox">
    <div class="login_box_close">
      <a href="javascript:void(0);" @click="loginBoxClose()"
        ><img src="~@/assets/image/login_box_close.png" alt=""
      /></a>
    </div>
    <div class="login_title">
      <img src="~@/assets/image/logo_2.png" alt="" />
    </div>
    <el-form class="login_form" :model="loginFormData" :rules="rules">
      <el-form-item>
        <el-input
          v-model="loginFormData.account"
          autocomplete="off"
          placeholder="账号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="loginFormData.password"
          autocomplete="off"
          placeholder="密码"
          show-password
        ></el-input>
      </el-form-item>
    </el-form>
    <el-row>
      <el-button type="success" class="login_btn" @click="login"
        >登录</el-button
      >
    </el-row>
    <el-row class="login_box_desc">
      <span class="login_tip_text">注册账号</span>和<span class="login_tip_text"
        >找回密码</span
      >请下载白金岛游戏
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      loginDialogTitle: false,
      loginFormData: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    showLoginBox: {
      get () {
        return this.$store.state.showLoginBox
      },
      set () {
        this.$store.commit('showLoginBox', false)
      }
    }
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    login () {
      var _that = this
      const account = this.loginFormData.account
      const password = this.loginFormData.password
      this.handleLogin({ account, password }).then(response => {
        const res = response.data
        if (res.code === 0) {
          this.getUserInfo().then(response => {
            const res = response.data
            if (res.code === 0) {
              this.$store.commit('showLoginBox', false)
              this.$message.success({
                message: '登录成功',
                customClass: 'zZindex',
                duration: 2000
              })
              location.reload()
            } else {
              this.$message.error({
                message: res.msg,
                customClass: 'zZindex',
                duration: 2000
              })
            }
          })
        } else {
          this.$message.error({
            message: res.msg,
            customClass: 'zZindex',
            duration: 2000
          })
        }
      }).catch(responseErr => {
        this.$message.error({
          message: responseErr.data.msg,
          customClass: 'zZindex',
          duration: 2000
        })
      })
    },
    openLoginBox () {
      this.loginDialogTitle = true
    },
    loginBoxClose () {
      this.$store.commit('showLoginBox', false)
      this.$store.commit('showBlackOver', 'none')
    }
  }
}
</script>

<style scoped>
.zZindex {
  z-index: 3333 !important;
}
.login_box {
  position: fixed;
  top: 20%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 420px;
  height: 350px;
  background-color: #fff;
  z-index: 99999999;
}
.login_box_close {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 10px;
  right: 10px;
}
.login_box_close img {
  width: 100%;
  height: 100%;
}
.login_title {
  width: 180px;
  margin: 20px 110px;
}
.login_title img {
  width: 100%;
}
.login_form {
  width: 300px;
  margin: 0 auto;
}
.login_btn {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  width: 300px;
  margin: 0 auto;
  display: block;
}
.login_box_desc {
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
}
.login_tip_text {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue